import { authenticatedFetch } from '../api';

export type ReferenceKind =
  | 'company'
  | 'company_location'
  | 'catalog'
  | 'product'
  | 'variant';

export type CommerceReference = {
  id: string;
  label: string;
  detail: string | null;
};

export async function searchCommerceReferences(
  kind: ReferenceKind,
  query: string,
): Promise<CommerceReference[]> {
  const params = new URLSearchParams({ kind, q: query, limit: '20' });
  const response = await authenticatedFetch(`/api/commerce/references?${params.toString()}`);
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { detail?: string } | null;
    throw new Error(body?.detail ?? `Could not search Shopify resources (${response.status})`);
  }
  const body = (await response.json()) as { references: CommerceReference[] };
  return body.references;
}
